<div class="gh-confirm confirm-status-action-modal">
  <div class="gh-empty-module">
    <div class="confirm-status-action-modal-icon-container mb-30px" data-test-id="confirm-status-action-modal-icon-container">
      <img src="/dist/img/{{ actionType }}-user.svg" alt="{{ actionType }} profile icon" />
    </div>
    <div class="confirm-status-action-modal-title text-2xl font-mediumbold" data-test-id="confirm-status-action-modal-title" *ngIf="title.textKey">
      {{ title.textKey | localize: { name: entity.name } }}
    </div>
    <div class="confirm-status-action-modal-legend text-xs mt-16px" data-test-id="confirm-status-action-modal-legend" *ngIf="legend.textKey">
      {{ legend.textKey | localize }}
    </div>
  </div>

  <gh-indicator [ghValue]="indicators.loading" (onReset)="resetIndicator('loading')" ghMessage="{{ 'loading' | localize }}"></gh-indicator>

  <div class="confirm-status-action-modal-actions text-center mt-32px" *ngIf="!indicators.loading" data-test-id="confirm-status-action-modal-actions">
    <ui-button uiType="primary" uiSize="large" uiShape="round" (click)="confirm.emit()" [attr.data-test-id]="'button-confirm-' + actionType">
      {{ actionButton.textKey | localize }}
    </ui-button>
    <ui-button class="ml-16px" uiType="default" uiSize="large" uiShape="round" (click)="close.emit()" data-test-id="confirm-status-action-modal-cancel-button">
      {{ "cancel" | localize }}
    </ui-button>
  </div>
</div>
